import type { ReactNode } from "react";
import { Button } from "@puts/button.component";

export function IntercomLink({ command, children }: IntercomLinkProps) {
  function handleClick() {
    if (!window.Intercom) {
      console.error("Intercom is not available.");
      return;
    }

    window.Intercom(command);
  }

  return (
    <Button variant="link" onClick={handleClick}>
      {children}
    </Button>
  );
}

type IntercomLinkProps = {
  command: string;
  children: ReactNode;
};
